export default {
    init() {
    },
    showAlerts(errors) {
        let err = '<ul class="mb-0">';
        $.each(errors, function (key) {
            err += '<li>' + errors[key] + '</li>';
        })
        err += '</ul>';
        $('.form-validation-errors').addClass(['alert', 'alert-danger']);
        $('.form-validation-errors').html(err);
        $('.form-validation-errors').removeClass(['d-none']);
    },
    hideAlerts() {
        $('.form-validation-errors').addClass(['d-none']);
        $('.form-validation-errors').html();
        $('.form-validation-errors').removeClass(['alert', 'alert-danger']);
    }
}
